import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	INVOICE_QUERY_KEY,
	PROJECTS_INVOICES_QUERY_KEY,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import UpdateInvoiceStatusForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoiceStatusSidebar/UpdateInvoiceStatusForm";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	invoiceData: Invoice
};

const UpdateInvoiceStatusSidebar: React.FunctionComponent<Props> = ({
	isOpen,
	onClose,
	invoiceData,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: INVOICE_QUERY_KEY(invoiceData.id) });
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		if (invoiceData.projectId) {
			queryClient.invalidateQueries({ queryKey: PROJECTS_INVOICES_QUERY_KEY(invoiceData.projectId) });
		}
		onClose();
	}, [invoiceData.id, invoiceData.projectId, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateInvoiceStatusForm onCancel={onClose}
												onSuccess={handleSuccess}
												invoiceData={invoiceData} />}
		</Sidebar>
	);
};

export default UpdateInvoiceStatusSidebar;
